import { ref } from 'vue';

export function useDriverDebugRange() {
	const start = ref<Date | null>(null);
	const end = ref<Date | null>(null);

	return {
		start,
		end,
	};
}
